<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="3">
        <wapi-panel :title="'Фильтр'">
          <template v-slot:content>
            <base-time v-if="userId" v-model="lastTime" />
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-select
                v-model="userId"
                :items="users"
                item-text="name"
                item-value="id"
                label="Клиент"
                @input="onChangeUser"
                :rules="[rules.required]"
                dense
                outlined
              ></v-select>
              <wapi-presets
                v-model="presetId"
                :disabled="!userId"
                :multiple="multiple"
                @input="onChangePreset"
                :rules="[rules.required]"
                close-after-select
                :userId="userId"
              />
            </v-form>
          </template>
        </wapi-panel>
      </v-col>
      <v-col cols="12" md="9">
        <v-alert type="info" v-if="!presetId">Выберите клиента и территорию</v-alert>
        <v-row v-if="presetId">
          <v-col class="pa-0">
            <!-- map -->
            <wapi-panel :title="'Настройка запросов для территории'" :spacing="false">
              <template v-slot:content>
                <div style="height: 415px;">
                  <l-map ref="map" :zoom="zoom" :center="center" style="z-index: 1">
                    <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
                    <l-geo-json
                      ref="geoJsonLayer"
                      v-if="show"
                      :geojson="geojson"
                      :options="geoJsonOptions"
                    />
                    <l-marker
                      v-for="marker in markers"
                      v-bind:key="marker.id"
                      :lat-lng="[marker.latitude, marker.longitude]"
                      @click="selectMarkerHandler(marker)"
                      :icon="marker.icon"
                    ></l-marker>
                  </l-map>
                </div>
                <!-- buttons -->
                <v-row class="ma-0">
                  <v-col class="pa-0">
                    <v-btn class="ma-2" color="primary" @click="forecastResult()">Выполнить запрос</v-btn>
                    <v-btn color="blue-grey" class="ma-2 white--text" @click="report()" dense>
                      EXCEL
                      <v-icon right dark>mdi-file-excel</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </wapi-panel>
          </v-col>
        </v-row>

        <wapi-card v-if="extended" class="mt-3">
          <template v-slot:content>
            <v-sheet>
              <v-tabs background-color="primary" dark>
                <v-tab>Параметры</v-tab>
                <v-tab>Заблаговременности</v-tab>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <selected-parameter-list :model="parametersLayers" />
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <select-predicts :model="predicts" />
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-sheet>
          </template>
        </wapi-card>
      </v-col>
    </v-row>

    <v-row class="ml-2">
      <v-col>
        <wapi-panel :title="'Результаты'" :spacing="false" v-if="result.parameters">
          <template v-slot:content>
            <v-tabs background-color="primary" dark>
              <v-tab>Таблица</v-tab>
              <v-tab>JSON</v-tab>
              <v-tab-item>
                <forecast-tabs
                  v-model="tabIndex"
                  :model="result"
                  :userId="userId"
                  :baseTime="lastTime"
                ></forecast-tabs>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <json-viewer :value="json" copyable boxed sort expanded :expand-depth="5"></json-viewer>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WapiContract from "../../models/contract/WapiContract";
import SelectedParameterList from "../../components/SelectedParameterList.vue";
import SelectPredicts from "../../components/SelectPredicts.vue";
import settings from "../../settings.json";
import rules from "../../models/helpers/rules";
import WapiPanel from "../../components/WapiPanel";
import WapiCard from "../../components/WapiCard";
import WapiPresets from "../../components/WapiPresets";
import { wapiPolygon2DToGeoJson } from "../../helpers/wapihelpers";
import WapiForecastMessageViewModel from "../../models/viewmodels/WapiForecastMessageViewModel";
import ForecastTabs from "../../components/ForecastTabs.vue";
import Point from "../../models/point.js";
import L from "leaflet";
import BaseTime from "../components/BaseTime.vue";

export default {
  name: "ForecastView",
  title: "Прогнозы",
  components: {
    SelectedParameterList,
    SelectPredicts,
    WapiPanel,
    WapiCard,
    WapiPresets,
    ForecastTabs,
    BaseTime
  },
  async mounted() {
    await this.$store.dispatch("FETCH_USERS");
    this.users = this.$store.getters.USERS;
  },
  data: function() {
    return {
      contractModel: new WapiContract(),
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          this.$refs.map.mapObject.fitBounds(bounds);
        }
      },
      tabIndex: 0,
      dvariants: [],
      predicts: [],
      userId: "",
      domain: "",
      presetId: "",
      users: [],
      presets: [],
      presetsViewModel: [],
      parameters: [],
      parametersLayers: [],
      extended: false,
      loading: false,
      show: true,
      enableTooltip: true,
      geojson: null,
      fillColor: "#e4ce7f",
      bounds: null,
      preset: null,
      zoom: settings.zoom,
      center: settings.center,
      valid: true,
      rules: rules,
      multiple: false,
      result: {},
      json: {},
      markers: [],
      coordinateOrder: [],
      iconSelectedMarker: L.icon({
        iconUrl: "/marker-icon-red.png"
      }),
      presetPoints: [],
      lastTime: null
    };
  },
  computed: {
    presetEnabled: function() {
      const isContract = !!this.contractModel;
      const result = isContract;
      return result;
    }
  },
  methods: {
    async onChangePreset(presetId) {
      try {
        if (!presetId) return;

        await this.$store.dispatch("FETCH_PRESET", {
          id: presetId,
          user_id: this.userId
        });
        this.preset = this.$store.getters.PRESET;
        this.geojson = wapiPolygon2DToGeoJson(this.$store.getters.PRESET);
        this.bounds = this.$refs.geoJsonLayer.getBounds();
        this.presetPoints = await this.$store.dispatch("FETCH_POINTS", {
          domain: this.preset.forecast_options.points_domains[0].domain,
          wapiPolygon2D: this.preset.area
        });
      } catch (err) {
        this.$store.dispatch("PUSH_ERROR", err);
      }
    },
    async onChangeUser(userId) {
      try {
        if (!userId) return;
        try {
          await this.$store.dispatch("FETCH_CONTRACTS", userId);
          let contractResponse = this.$store.getters.CONTRACT_BY_USERID(userId);
          this.coordinateOrder =
            contractResponse.preset_settings.coordinate_order;
          if (!contractResponse || contractResponse?.status !== 1) {
            this.$store.dispatch(
              "PUSH_ERROR_MESSAGE",
              `У пользователя "${userId}" отсутствует договор!`
            );
            this.contractModel = null;
            return;
          }

          this.lastTime = await this.$store.dispatch(
            "FETCH_FORECAST_LAST_TIME_USER",
            { userId }
          );
        } catch (err) {
          this.$store.dispatch("PUSH_ERROR", err);
        }

        this.presetId = null;
      } catch (err) {
        this.$store.dispatch("PUSH_ERROR", err);
      }
    },
    async report() {
      if (!this.$refs.form.validate()) return;

      await this.$store.dispatch("SET_LOADING", true);
      const request = {
        lat: this.presetPoints[0].location.x,
        lon: this.presetPoints[0].location.y,
        presetId: this.presetId,
        userId: this.userId
      };

      await this.$store.dispatch("FORECAST_REPORT", request);

      await this.$store.dispatch("SET_LOADING", false);
    },
    async forecastResult() {
      if (!this.$refs.form.validate()) return;

      await this.$store.dispatch("SET_LOADING", true);
      const forecast = await this.$store.dispatch("FETCH_FORECAST_PRESET", {
        user_id: this.userId,
        preset_id: this.presetId
      });

      if (!forecast) {
        await this.$store.dispatch(
          "PUSH_ERROR_MESSAGE",
          "Нет данных для отображения"
        );
        await this.$store.dispatch("SET_LOADING", false);
        return;
      }

      this.result = new WapiForecastMessageViewModel().map(
        forecast,
        this.coordinateOrder
      );
      this.json = forecast;

      let number = 0;
      this.markers = this.result.pointGroups.map(p => {
        const point = new Point();
        point.id = number++;
        point.latitude = p.latitude;
        point.longitude = p.longitude;
        point.icon = new L.Icon.Default();
        return point;
      });

      await this.$store.dispatch("SET_LOADING", false);
    },
    async selectMarkerHandler(point) {
      this.tabIndex = point.id;
      this.selectMarker(point.id);
    },

    async selectMarker(id) {
      this.markers.forEach(x => {
        if (x.id === id) {
          x.icon = this.iconSelectedMarker;
        } else {
          x.icon = new L.Icon.Default();
        }
      });
    }
  },
  watch: {
    tabIndex(value) {
      if (value) {
        this.selectMarker(value);
      }
    }
  }
};
</script>
<style scoped>
/* .basetime_container {
  display: flex;
  align-items: center;
}
.basetime_minute {  
    font-size: 7pt;
    vertical-align: top;
    line-height: 20px;

} */
</style>